var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showFloatingTour)?_c('FloatingTour',{attrs:{"tour":_vm.floatingSteps},on:{"complete":_vm.handleFloatingComplete}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }